import { render, staticRenderFns } from "./ForWaringUser.vue?vue&type=template&id=3c7b8514&scoped=true&name=forwaringUser&"
import script from "./ForWaringUser.vue?vue&type=script&lang=js&"
export * from "./ForWaringUser.vue?vue&type=script&lang=js&"
import style0 from "./ForWaringUser.vue?vue&type=style&index=0&id=3c7b8514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b8514",
  null
  
)

export default component.exports